import { type StoryblokProductSearchFilterCategoriesType } from '../../../../storyblok'
import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

import { storyblokProductSearchFiltersGetValuesFromString } from './storyblokProductSearchFiltersGetValuesFromString'

export const storyblokProductSearchFiltersGetCategories = (
  categoryFilters: StoryblokProductSearchFilterCategoriesType,
): Partial<Pick<StoryblokProductSearchFiltersType, 'categoryCodes'>> => {
  return {
    categoryCodes: storyblokProductSearchFiltersGetValuesFromString(
      categoryFilters.categoryIds,
    ),
  }
}
